import { useEffect, useState } from 'react';
import * as cookieHelper from './cookieHelper';

const BANNER_KEYS = ['left', 'rightTop', 'rightBottom'];

// Share one session refresh across components on the same page.
let sessionRefreshPromise = null;

export const resetSessionRefresh = () => {
    sessionRefreshPromise = null;
};

export const ensureSessionRefreshed = async () => {
    if (typeof window === 'undefined') return false;
    if (!sessionRefreshPromise) {
        sessionRefreshPromise = cookieHelper.refreshSessionData().catch(() => {
            sessionRefreshPromise = null;
            return false;
        });
    }

    return sessionRefreshPromise;
};

// --- login ---

export const isUserLoggedIn = () => {
    if (typeof document === 'undefined') return false;
    const cookies = cookieHelper.getCookie();
    return !!(cookies && cookies.zd_mid);
};

// Returns [isLoggedIn, ready]. Wait for ready before gating protected content.
export const useLoginStatus = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;

        async function syncLoginStatus() {
            await ensureSessionRefreshed();
            if (cancelled) return;
            setIsLoggedIn(isUserLoggedIn());
            setReady(true);
        }

        syncLoginStatus();

        const onAuthChange = () => {
            resetSessionRefresh();
            setReady(false);
            syncLoginStatus();
        };

        document.addEventListener('signin', onAuthChange);
        document.addEventListener('signoff', onAuthChange);
        return () => {
            cancelled = true;
            document.removeEventListener('signin', onAuthChange);
            document.removeEventListener('signoff', onAuthChange);
        };
    }, []);

    return [isLoggedIn, ready];
};

// --- protected rules ---

export const isProtectedItem = (item) => Number(item?.protected) === 1;

export const canViewItem = (item, loggedIn) => !isProtectedItem(item) || !!loggedIn;

// --- filters ---

export const filterProtectedList = (items, loggedIn) => {
    if (!Array.isArray(items)) return items;
    return items.filter((item) => canViewItem(item, loggedIn));
};

export const filterProtectedContent = (payload, loggedIn) => {
    if (!payload) return payload;

    if (Array.isArray(payload)) {
        return filterProtectedList(payload, loggedIn);
    }

    if (typeof payload === 'object') {
        const next = { ...payload };

        if (Array.isArray(next.data)) {
            next.data = filterProtectedList(next.data, loggedIn);
        }

        BANNER_KEYS.forEach((key) => {
            if (Array.isArray(next[key])) {
                next[key] = filterProtectedList(next[key], loggedIn);
            }
        });

        return next;
    }

    return payload;
};
